import type { ReactNode } from 'react'

import './contentWrapper.scss'

interface ContentWrapperProps {
  children: ReactNode
}

const ContentWrapper = ({ children }: ContentWrapperProps) => <div className='content-wrapper'>{children}</div>

export default ContentWrapper
